import { render } from "./LpBase.vue?vue&type=template&id=70779dec"
import script from "./LpBase.vue?vue&type=script&lang=js"
export * from "./LpBase.vue?vue&type=script&lang=js"

import exportComponent from "/home/test/Documents/GitHub/LpMooveTrainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__